import Vue from 'vue';
import App from './App.vue';
import router from './routes/router';
import 'bootstrap/dist/css/bootstrap.min.css';

import 'vue-search-select/dist/VueSearchSelect.css';
import store from './store';

import diasSemanaFilter from "./filtros/dias-semana.filter";
import dateFilter  from "./filtros/date.filter";

import VueClipboard from 'vue-clipboard2';
import Popover from 'vue-js-popover';

// Global Components
import './global-components'

// Global Components
import './global-components'

Vue.config.productionTip = false;

// Componente para copiar al portapapeles
VueClipboard.config.autoSetContainer = true   // Esta linea es necesaria para que pueda funcionar con modales de bootstrap
Vue.use(VueClipboard);

Vue.use(Popover);



// Filtros globales
diasSemanaFilter;
dateFilter


new Vue({
  router,
  render: h => h(App),
  store: store
}).$mount('#app')
